import { render, staticRenderFns } from "./IQalaOrderCard.vue?vue&type=template&id=d6bab0a4&"
import script from "./IQalaOrderCard.vue?vue&type=script&lang=js&"
export * from "./IQalaOrderCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports